import React, { useState } from 'react';

const PasswordContainer = ({onChange,text}) => {
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
    onChange(e.target.value);
  };

  const toggleShowPassword = () => {
    setShowPassword(!showPassword);
  };

  return (
    
      
      <input
        className='edit-text'
        type={showPassword ? 'text' : 'password'}
        id="password"
        placeholder={text}
        value={password}
        onChange={handlePasswordChange}
      />
      
    
  );
};

export default PasswordContainer;

